import React, { useMemo } from "react";
import * as THREE from "three";
import type { RingDefinition } from "../../types/celestialBody";
import type { VisualizationScale } from "../../types/astronomy";
import { toSceneRadius } from "../../utils/scaling";
import { degToRad } from "../../astronomy/kepler";

interface PlanetaryRingsProps {
  rings: RingDefinition[];
  scale: VisualizationScale;
  axialTiltDeg: number;
}

export function PlanetaryRings({
  rings,
  scale,
  axialTiltDeg,
}: PlanetaryRingsProps) {
  const geometries = useMemo(
    () =>
      rings.map((ring) => ({
        inner: toSceneRadius(ring.innerRadiusKm, scale),
        outer: toSceneRadius(ring.outerRadiusKm, scale),
        opacity: ring.opacity,
        inclination: degToRad(ring.inclinationDeg),
      })),
    [rings, scale],
  );

  return (
    <group rotation={[0, 0, degToRad(axialTiltDeg)]}>
      {geometries.map((ring, index) => (
        <mesh
          key={index}
          rotation={[Math.PI / 2 + ring.inclination, 0, 0]}
        >
          <ringGeometry args={[ring.inner, ring.outer, 128]} />
          <meshStandardMaterial
            color="#d8c9a0"
            transparent
            opacity={ring.opacity}
            side={THREE.DoubleSide}
            roughness={0.8}
            metalness={0.1}
            depthWrite={false}
          />
        </mesh>
      ))}
    </group>
  );
}
